<template>
    <div class="overview">
        <v-card>
            <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex v-for="card in cards" v-bind="{ [`xs${card.flex}`]: true }" :key="card.title">
                <v-card>
                    <v-img :src="card.src" height="280px">
                    <v-container fill-height fluid pa-2>
                        <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                            <span class="headline white--text" v-text="card.title"></span>
                        </v-flex>
                        </v-layout>
                    </v-container>
                    </v-img>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                        <v-icon>favorite</v-icon>
                    </v-btn>
                    <v-btn icon>
                        <v-icon>radio_button_checked</v-icon>
                    </v-btn>
                    <v-btn icon>
                        <v-icon>check_box</v-icon>
                    </v-btn>
                    <v-btn icon>
                        <v-icon>android</v-icon>
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-flex>
            </v-layout>
            </v-container>
        </v-card>
    </div>
</template>


<script>
export default {
  name: 'overview',
  data: () => ({
    cards: [
      { title: 'Szene 1', src: 'https://balloop.art/images/gallery/balloop/background@1x.jpg', flex: 12 },
      { title: 'Szene 2', src: 'https://balloop.art/images/gallery/balloop/event-vrhq2.jpg', flex: 6 },
      { title: 'Szene 3', src: 'https://balloop.art/images/gallery/balloop/atelier1.jpg', flex: 6 },
      { title: 'Szene 4', src: 'https://balloop.art/images/gallery/balloop/atelier1.jpg', flex: 6 },
      
    ],
  }),
};
</script>

<style>
    .overview {
        margin-top: 50px;
    }
</style>
